(function(){
     'use strict';

     angular
        .module('appback')
        .factory('ProductosService', ProductosService);

    ProductosService.$inject = ['$http'];

    function ProductosService($http){


        var service= {
            getProductos: getProductos,
            getProductoPaisData: getProductoPaisData,
            updatePriorityPais: updatePriorityPais,
            updatePriorityProductoPais: updatePriorityProductoPais,
            updateStatus: updateStatus
        };

        return service;

        function getProductos(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
            });
            $http.post('/backend/productos/getproductos', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function updatePriorityPais(id, priority, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                id: id,
                priority: priority
            });
            $http.post('/backend/regulatory/updateprioritypais', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function updatePriorityProductoPais(idProducto, idPais, priority, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            };

            var data = $.param({
                producto_id: idProducto,
                pais_id: idPais,
                priority: priority
            });
            $http.post('/backend/regulatory/updatepriorityproductopais', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            };
            function getContentFailed(data){
                callback(data);
            };
        }

        function getProductoPaisData(productoId, paisId, callback)
        {
            $http.get('/backend/regulatory/getproductopaisdata', {
                params: {
                    producto_id: productoId,
                    pais_id: paisId
                }
            })
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function updateStatus(productoId, paisId, estadoId, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                producto_id: productoId,
                pais_id: paisId,
                estado_id: estadoId
            });
            $http.post('/backend/regulatory/updatestatus', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

    }
})();